import React from "react";

const PrivacyPolicy = () => {
  return (
    <div className="max-w-5xl mx-auto p-8">

      <h1 className="text-3xl font-bold mb-6">
        EarnProjectAcademy – Privacy Policy
      </h1>

      <p className="mb-4">
        Your privacy is important to us at EarnProjectAcademy. This policy
        explains how we collect, use, store, and protect your personal
        information when you interact with our platform, courses, or services.
      </p>

      <p className="mb-6">
        <strong>Effective Date:</strong> January 2025
      </p>

      <p>
        This privacy policy applies to all users of the EarnProjectAcademy
        platform and services.
      </p>

      <h2 className="text-xl font-semibold mt-6">
        1. What Information Do We Collect?
      </h2>

      <ul className="list-disc ml-6 mt-3 space-y-2">
        <li>
          Personal information such as name, email address, phone number, and
          mailing address.
        </li>

        <li>
          Technical information including IP address, browser type, and device
          operating system.
        </li>

        <li>
          Payment and transaction information processed securely through
          third-party payment providers.
        </li>
      </ul>

      <p className="mt-3">
        This information helps us provide our services, improve your experience,
        and communicate important updates.
      </p>

      <h2 className="text-xl font-semibold mt-6">
        2. Email & Communication Consent
      </h2>

      <p>
        With your consent, EarnProjectAcademy may contact you through email,
        SMS, or WhatsApp regarding course updates, offers, and learning
        information.
      </p>

      <p className="mt-2">
        You can unsubscribe at any time by clicking the unsubscribe link in
        emails or by contacting us at support@earnprojectacademy.com.
      </p>

      <h2 className="text-xl font-semibold mt-6">
        3. How We Use Your Information
      </h2>

      <ul className="list-disc ml-6 mt-3 space-y-2">

        <li>Deliver our courses and services</li>

        <li>Resolve technical or account-related issues</li>

        <li>Personalize your learning experience</li>

        <li>Send updates, invoices, and important notifications</li>

        <li>Prevent fraud or misuse of the platform</li>

        <li>Improve our platform using analytics and research</li>

        <li>Enforce our terms, policies, and regulations</li>

      </ul>

      <h2 className="text-xl font-semibold mt-6">
        4. Consent & Withdrawal
      </h2>

      <p>
        By registering or enrolling in our programs, you consent to the use of
        your information for service delivery. For marketing or optional
        communications, explicit consent may be requested. You may withdraw your
        consent anytime by emailing support@earnprojectacademy.com.
      </p>

      <h2 className="text-xl font-semibold mt-6">
        5. Disclosure of Information
      </h2>

      <p>
        EarnProjectAcademy does not sell or rent user data. Information may only
        be disclosed if required by law, necessary to enforce our policies, or
        to protect our legal rights.
      </p>

      <h2 className="text-xl font-semibold mt-6">
        6. Payment Data Security
      </h2>

      <p>
        We use secure payment gateways such as Razorpay for processing payments.
        These gateways are PCI-DSS compliant and use encryption to protect
        financial information. EarnProjectAcademy does not store complete card
        details.
      </p>

      <h2 className="text-xl font-semibold mt-6">
        7. Third-Party Services & Links
      </h2>

      <p>
        Our platform may include integrations with third-party services such as
        analytics tools or payment providers. Their respective privacy policies
        apply when interacting with those services.
      </p>

      <h2 className="text-xl font-semibold mt-6">
        8. Data Protection & Security
      </h2>

      <p>
        We follow industry-standard security practices including encryption,
        secure protocols, and restricted access to protect your personal data.
      </p>

      <h2 className="text-xl font-semibold mt-6">
        9. Cookies Policy
      </h2>

      <p>
        Cookies are used on our platform to maintain login sessions, improve
        performance, and analyze user behavior. You can control cookies through
        your browser settings.
      </p>

      <h2 className="text-xl font-semibold mt-6">
        10. Age of Consent
      </h2>

      <p>
        By using EarnProjectAcademy services, you confirm that you are legally
        eligible to enroll or have parental/guardian consent.
      </p>

      <h2 className="text-xl font-semibold mt-6">
        11. Changes to This Policy
      </h2>

      <p>
        We may update this privacy policy periodically. Major changes will be
        communicated through email or platform notifications.
      </p>

      <h2 className="text-xl font-semibold mt-6">
        12. Contact Us
      </h2>

      <p>
        For privacy-related questions, corrections, or data deletion requests,
        please contact us:
      </p>

      <p className="mt-2">
        📧 Email: support@earnprojectacademy.com
      </p>

      <p>
        🌐 Website: https://earnprojectacademy.com
      </p>

    </div>
  );
};

export default PrivacyPolicy;